import { toast } from 'react-toastify';

import type { DonationBenefitToastProps } from '@/app/donation/_components/DonationBenefitToast/DonationBenefitToast';
import { DonationBenefitToast } from '@/app/donation/_components/DonationBenefitToast/DonationBenefitToast';

const DONATION_BENEFIT_TOAST_ID = 'donation-benefit-toast';

/**
 * 고향사랑 기부 혜택을 알려주는 광고성 토스트
 */
export const useDonationBenefitToast = () => {
  const toastDonationBenefit = ({
    theme,
    href,
  }: Pick<DonationBenefitToastProps, 'theme' | 'href'>) => {
    toast(
      ({ closeToast }) => (
        <DonationBenefitToast
          onClose={() => {
            closeToast();
          }}
          theme={theme}
          href={href}
        />
      ),
      {
        position: 'bottom-center',
        autoClose: false,
        //* per-toast className은 컨테이너 toastClassName(중앙정렬 포함)을 대체하므로 justify-center로 본문을 다시 중앙정렬
        className:
          '!bg-transparent !p-0 !shadow-none pointer-events-none justify-center',
        // 고유 ID를 부여하여 중복 생성을 방지하고, 외부에서 토스트를 제어할 수 있도록 합니다.
        toastId: DONATION_BENEFIT_TOAST_ID,
      },
    );
  };

  /**
   * 기부 혜택 토스트를 닫습니다.
   */
  const dismissDonationBenefitToast = () => {
    toast.dismiss(DONATION_BENEFIT_TOAST_ID);
  };

  return {
    toastDonationBenefit,
    dismissDonationBenefitToast,
  };
};
